<script setup>
import { NuxtLink } from '#components'

const props = defineProps({
  teaser: {
    type: Object,
    required: true,
  },
})
</script>

<template>
  <component
    :is="props.teaser.button?.to ? NuxtLink : 'div'"
    :to="props.teaser.button?.to"
    class="d-flex teaser"
  >
    <div
      v-if="props.teaser?.image"
      class="teaser__image"
    >
      <NuxtImg
        sizes="sm:340px md:440px lg:800px"
        densities="1x 2x"
        :src="props.teaser.image.src"
        :alt="props.teaser.image.alt"
        loading="lazy"
        format="webp"
        :placeholder="[300, 200, 60, 2]"
      />
    </div>
    <div class="d-flex flex-column teaser__content">
      <div
        class="equal-small-2 equal-small-2--bold-uppercase teaser__info"
      >
        {{ props.teaser.info }}
      </div>
      <h3 class="scale-3 scale-3--bold-uppercase">
        {{ props.teaser.title }}
      </h3>
      <FormButton
        v-if="props.teaser?.button?.label"
        class="l-button--outlined teaser__button"
        :label="props.teaser.button.label"
        component="div"
      />
    </div>
  </component>
</template>

<style lang="scss" scoped>
@import '~/assets/scss/variables.scss';
@import 'bootstrap/scss/mixins';

.teaser {
  height: clamp(425px, 21.88vw + 355px, 740px);
  width: 100%;
  position: relative;
  overflow: hidden;

  &__image {
    position: relative;
    display: flex;
    width: 100%;
    height: auto;

    img {
      position: relative;
      display: flex;
      object-fit: cover;
      min-width: 100%;
      min-height: 100%;
      transition: 0.5s ease;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 100%;
      background: linear-gradient(
        rgba(0, 0, 0, 0.1) 0%,
        rgba(0, 0, 0, 0.1) 30%,
        rgba(0, 0, 0, 0.5) 70%,
        rgba(0, 0, 0, 0.5) 100%
      );
    }
  }

  &__content {
    position: absolute;
    text-align: left;
    bottom: 0;
    left: 0;
    padding: clamp(25px, 1.04vw + 21.67px, 40px) clamp(20px, 1.39vw + 15.56px, 40px);
    margin-top: auto;
    max-height: 100%;
    width: 100%;

    @include media-breakpoint-down(640) {
      padding: 25px 20px;
    }
  }

  &__info {
    opacity: 0.7;
    margin-bottom: 5px;
  }

  &__button {
    margin-top: clamp(10px, 0.69vw + 7.78px, 20px);
  }

  &:hover,
  &:focus,
  &:active {
    transition: 0.5s ease;

    .teaser__image {
      img {
        transform: scale(1.05);
        transition: 0.5s ease;
      }
    }
  }
}
</style>
